import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SideNavigationContainer from "./SideNavigationContainer";
import { setNavActiveItem } from "@template/state/modules/navigation";
import { addLastFocusElement } from "@template/state/modules/layout";
import {
  getFeature,
  getFeaturesLoaded
} from "@template/state/modules/features";

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { setNavActiveItem, addLastFocusElement },
    dispatch
  );
}

const mapStateToProps = state => {
  const marketplaceVintageLinkMobile = getFeature(
    state,
    "emf-137-mweb-marketplace-clothing-nav-edit"
  );

  return {
    marketplaceVintageLinkMobile: marketplaceVintageLinkMobile,
    testIsLoaded: getFeaturesLoaded(state)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SideNavigationContainer);
